<div class="asset-io-badge" *ngIf="assetIoService.hasIoInputs(asset)">
    <zui-lozenge type="information" text="{{assetIoService.getBadgeText(asset)}}"></zui-lozenge>
</div>
